/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-13 10:10:25
 * @LastEditTime: 2020-12-14 14:35:12
 * @Description: 销售订单store
 */
import {
    getManyFactorySalesOrder,
    updateSalesOrder,
    cancelSalesOrder,
    createSalesOrder,
    getSalesOrderList,
    changeSalesOrderProgress,
    getSalesOrderByFactoryId,
    createSalesOrderMulti,
    salesOrderReturn,
    salesOrderVolByDay,
    salesOrderVolByMonth,
    getRecommendSalesOrder,
    calcSalesOrderProfit,
    coverSalesOrdersCalc,
    getSalesOrderProfit
} from '@/api/salesOrder'
import Vue from 'vue'
import dayjs from 'dayjs'

const state = {
    factorySalesOrderList: [],
    salesOrderList: [],
    totalCounts: 0,
    planArrivedAt: undefined,
    salesOrderProfitList: [],
    salesOrderProfitTotalCounts: [],
}

const getters = {
    getSalesOrderById: (state) => (id) => {
        const index = state.salesOrder.findIndex(x => x._id === id)
        return index === -1 ? null : state.salesOrder[index]
    }
}

const actions = {
    async getManyFactorySalesOrderAction({
        commit
    }, payload) {
        try {
            const factorySalesOrderList = await getManyFactorySalesOrder(payload);
            commit('SET_FACTORY_SALES_ORDER_LIST', factorySalesOrderList.data)
        } catch (error) {
            throw error.message
        }
    },
    async getSalesOrderListAction({
        commit
    }, payload) {
        try {
            const salesOrderList = await getSalesOrderList(payload);
            commit('SETSALESORDERLIST', salesOrderList.data)
        } catch (error) {
            throw error.message
        }
    },
    async getSalesOrderTableAction({
        commit
    }, payload) {
        try {
            const salesOrderList = await getSalesOrderList(payload);
            commit('SET_SALES_ORDER_TABLE', salesOrderList.data)
        } catch (error) {
            throw error.message
        }
    },
    async createSalesOrderAction({
        commit
    }, payload) {
        try {
            const salesOrder = await createSalesOrder(payload);
            commit('UPDATE_SALES_ORDER_LIST', salesOrder.data)
        } catch (error) {
            throw error.message
        }
    },
    async createSalesOrdMultierAction({
        commit
    }, payload) {
        try {
            const salesOrder = await createSalesOrderMulti(payload);
            commit('UPDATE_SALES_ORDER_LIST', salesOrder.data)
        } catch (error) {
            throw error.message
        }
    },
    async updateSalesOrderAction({
        commit
    }, payload) {
        try {
            const newSalesOrder = await updateSalesOrder(payload.id, payload.data);
            const {
                type
            } = payload;
            if (!type) {
                commit('UPDATESALESOREDER', newSalesOrder.data)
            }
            return newSalesOrder.data
        } catch (error) {
            throw error.message
        }
    },
    async cancelSalesOrderAction({
        commit
    }, payload) {
        try {
            const salesOrder = await cancelSalesOrder(payload.id, payload.data);
            commit('CANCEL_SALESORDER', salesOrder.data)
        } catch (error) {
            throw error.message
        }
    },
    async changeSalesOrderProgressAction({
        commit
    }, payload) {
        try {
            await changeSalesOrderProgress(payload.id, payload.data)
        } catch (error) {
            throw error.message
        }
    },
    async getSalesOrderByFactoryIdAction({
        commit
    }, payload) {
        try {
            const factorySalesOrder = await getSalesOrderByFactoryId(payload.id, payload.data);
            commit('UPDATEFACTORYSALESORDERLIST', factorySalesOrder.data)
        } catch (error) {
            throw error.message
        }
    },
    async cancelSalesProdOrderAction({
        commit
    }, payload) {
        try {
            const salesOrder = await cancelSalesOrder(payload.id, payload.data);
            commit('CANCELSALEPRODSORDER', salesOrder.data)
        } catch (error) {
            throw error.message
        }
    },
    async updateSalesProdOrderAction({
        commit
    }, payload) {
        try {
            const newSalesOrder = await updateSalesOrder(payload.id, payload.data);
            const {
                type
            } = payload;
            if (!type) {
                commit('UPDATE_SALES_PROD_OREDER', newSalesOrder.data)
            }
            return newSalesOrder.data
        } catch (error) {
            throw error.message
        }
    },
    async salesOrderReturnAction({
        commit
    }, payload) {
        try {
            const newSalesOrder = await salesOrderReturn(payload.id, payload.data);
            commit('SALES_OREDER_RETURN', newSalesOrder.data)
            return newSalesOrder.data
        } catch (error) {
            throw error.message
        }
    },
    async salesOrderVolByDayAction({
        commit
    }, payload) {
        try {
            const salesOrderVolByDayList = await salesOrderVolByDay(payload);
            return salesOrderVolByDayList.data
        } catch (error) {
            throw error.message
        }
    },
    async salesOrderVolByMonthAction({
        commit
    }, payload) {
        try {
            const salesOrderVolByMonthList = await salesOrderVolByMonth(payload);
            return salesOrderVolByMonthList.data
        } catch (error) {
            throw error.message
        }
    },
    async getRecommendSalesOrder({}, payload) {
        try {
            const salesOrderVolByMonthList = await getRecommendSalesOrder(payload);
            return salesOrderVolByMonthList.data
        } catch (error) {
            throw error.message
        }
    },

    async getSalesOrderProfitListAction({
        commit
    }, payload) {
        try {
            const salesOrderProfitList = await getSalesOrderProfit(payload);
            commit('SET_SALES_ORDER_PROFIT_LIST', salesOrderProfitList.data)
        } catch (error) {
            throw error.message
        }
    },

    async calcSalesOrderProfitAction({
        commit
    }, payload) {
        try {
            await calcSalesOrderProfit(payload)
        } catch (error) {
            throw error
        }
    },
    async coverSalesOrdersCalcAction({
        commit
    }, payload) {
        try {
            await coverSalesOrdersCalc(payload)
        } catch (error) {
            throw error
        }
    },
}

const mutations = {
    SETPLANARRIVEDAT(state, payload) {
        state.planArrivedAt = payload
    },
    SET_FACTORY_SALES_ORDER_LIST(state, payload) {
        // 按照计划生产时间排序，没有则是需求时间
        // payload.forEach(f => {
        //     f.salesOrderList.sort((a, b) => {
        //         if (!a.producedAtPlan && !b.producedAtPlan) return dayjs(a.planArrivedAt).toDate() - dayjs(b.planArrivedAt).toDate();
        //         if (a.producedAtPlan && !b.producedAtPlan) return -1;
        //         return dayjs(a.producedAtPlan).toDate() - dayjs(b.producedAtPlan).toDate()
        //     })
        // })
        state.factorySalesOrderList = payload
    },
    SETSALESORDERLIST(state, payload) {
        state.salesOrderList = salesOrderSortByindexInDay(payload.salesOrderList);
        state.totalCounts = payload.totalCounts
    },
    SET_SALES_ORDER_TABLE(state, payload) {
        state.salesOrderList = payload.salesOrderList;
        state.totalCounts = payload.totalCounts
    },
    UPDATEFACTORYSALESORDERLIST(state, salesOrderList) {
        Vue.set(state.factorySalesOrderList, state.factorySalesOrderList.findIndex(x => x._id === salesOrderList._id), salesOrderList)
    },
    UPDATEFACTORYSALESORDERDELIVERY(state, delivery) {
        let [salesOrderIndex, factoryIndex] = [null, null];
        state.factorySalesOrderList.map((x, fIndex) => {
            x.salesOrder.map((s, sIndex) => {
                if (s.delivery._id === delivery._id) {
                    factoryIndex = fIndex;
                    salesOrderIndex = sIndex
                }
            })
        });
        Vue.set(state.factorySalesOrderList[factoryIndex].salesOrder[salesOrderIndex], 'delivery', delivery)
    },
    UPDATE_SALES_ORDER_LIST(state, salesOrder) {
        let factoryIndex = null;
        state.factorySalesOrderList.map((x, index) => {
            if (x.factory._id === salesOrder[0].factory._id) factoryIndex = index
        });
        for (let i = 0; i < salesOrder.length; i++) {
            const data = salesOrderSort([...state.factorySalesOrderList[factoryIndex].salesOrder.filter(x => x._id !== salesOrder._id), salesOrder[i]]);
            state.factorySalesOrderList[factoryIndex].salesOrder = data
            state.factorySalesOrderList[factoryIndex].totalCounts++
        }
    },
    CANCEL_SALESORDER(state, salesOrder) {
        let factoryIndex = null;
        state.factorySalesOrderList.map((x, index) => {
            if (x.factory._id === salesOrder.factory._id) factoryIndex = index
        });
        const salesOrderList = state.factorySalesOrderList[factoryIndex].salesOrder.filter((s) => s._id !== salesOrder._id);
        Vue.set(state.factorySalesOrderList[factoryIndex], 'salesOrder', salesOrderList)
        state.factorySalesOrderList[factoryIndex].totalCounts--
    },
    UPDATESALESOREDER(state, salesOrder) {
        let factoryIndex = null;
        state.factorySalesOrderList.map((x, fIndex) => {
            x.salesOrder.map(s => {
                if (s._id === salesOrder._id) factoryIndex = fIndex;
            })
        });
        const data = salesOrderSort([...state.factorySalesOrderList[factoryIndex].salesOrder.filter(x => x._id !== salesOrder._id), salesOrder]);
        state.factorySalesOrderList[factoryIndex].salesOrder = data
        let statistic = 0;
        state.factorySalesOrderList[factoryIndex].salesOrder.map(x => statistic += x.volPlan)
        Vue.set(state.factorySalesOrderList[factoryIndex], 'statistic', statistic);
        state.salesOrderList = salesOrderSortByindexInDay(state.factorySalesOrderList[factoryIndex].salesOrder);
    },
    CANCELSALEPRODSORDER(state, salesOrder) {
        state.salesOrderList = state.salesOrderList.filter(x => x._id !== salesOrder._id);
        state.totalCounts--;
    },
    UPDATE_SALES_PROD_OREDER(state, salesOrder) {
        Vue.set(state.salesOrderList, state.salesOrderList.findIndex(x => x._id === salesOrder._id), salesOrder)
        state.salesOrderList = salesOrderSortByindexInDay(state.salesOrderList);
    },

    SALES_OREDER_RETURN(state, salesOrder) {
        let [salesOrderIndex, factoryIndex] = [null, null];
        state.factorySalesOrderList.map((x, fIndex) => {
            x.salesOrder.map((s, sIndex) => {
                if (s._id === salesOrder._id) {
                    factoryIndex = fIndex;
                    salesOrderIndex = sIndex
                }
            })
        });
        Vue.set(state.factorySalesOrderList[factoryIndex].salesOrder, salesOrderIndex, salesOrder);
    },

    SET_SALES_ORDER_PROFIT_LIST(state, payload) {
        state.salesOrderProfitList = payload.stat;
        state.salesOrderProfitTotalCounts = payload.totalCounts
    },
}

/**
 * @description 按照计划生产时间排序，没有则是需求时间
 * @param {Array} array 目标集合
 */
const salesOrderSort = (array) => {
    array.sort((a, b) => {
        if (!a.producedAtPlan && !b.producedAtPlan) return dayjs(a.planArrivedAt).toDate() - dayjs(b.planArrivedAt).toDate();
        if (a.producedAtPlan && !b.producedAtPlan) return -1;
        return dayjs(a.producedAtPlan).toDate() - dayjs(b.producedAtPlan).toDate()
    });
    return array
}

const salesOrderSortByindexInDay = (array) => {
    array.sort((a, b) => {
        return a.indexInDay - b.indexInDay
    });
    return array
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}